import React from 'react';
import Badge from '@lsq/nextgen/v2/badge';
import { dashboardCardConstants } from '../../constants/globalConstant';
import { ReactComponent as EditIcon } from './../../assets/svgIcons/lsq_edit.svg';
import styles from './styles.module.css';

/**
 * Wrapper around @lsq/nextgen/v2/badge for feature status display.
 * Swap this file to change the underlying badge library project-wide.
 *
 * Props:
 *   status — one of dashboardCardConstants: PUBLISHED | UNPUBLISHED | DRAFT | UNPUBLISHED_CHANGES
 *   size   — "sm" | "md" | "lg" (default "sm")
 */

const StatusDot = ({ className }) => (
  <svg
    className={className}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="currentColor" />
  </svg>
);

const STATUS_TO_BADGE = {
  [dashboardCardConstants.PUBLISHED]: {
    badgeStatus: 'success',
    label: 'Published'
  },
  [dashboardCardConstants.UNPUBLISHED]: {
    badgeStatus: 'overdue',
    label: 'Unpublished'
  },
  [dashboardCardConstants.UNPUBLISHED_CHANGES]: {
    badgeStatus: 'pending',
    label: (
      <span className={styles.editedLabel}>
        <EditIcon className={styles.editIcon} />
        Published
      </span>
    )
  },
  [dashboardCardConstants.DRAFT]: {
    badgeStatus: 'neutral',
    label: 'Draft'
  }
};

const LsqStatusBadge = React.memo(function LsqStatusBadge({
  status,
  size = 'sm',
  variant = 'badge'
}) {
  const config = STATUS_TO_BADGE[status];
  if (!config) return null;
  if (variant === 'dot') {
    return (
      <Badge
        customStyleClass={styles.dotBadge}
        status={config.badgeStatus}
        size={size}
        children={<StatusDot />}
      />
    );
  }

  return (
    <Badge status={config.badgeStatus} size={size}>
      {config.label}
    </Badge>
  );
});

export default LsqStatusBadge;
